import { render, staticRenderFns } from "./UploadCardBodyRadio.vue?vue&type=template&id=4f644c22&"
import script from "./UploadCardBodyRadio.vue?vue&type=script&lang=js&"
export * from "./UploadCardBodyRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports